exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".center-block{display:block;margin-left:auto;margin-right:auto}` .pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.clearfix:after{content:\".\";display:block;height:0;visibility:hidden;clear:both}.list-unstyled{padding-left:0;list-style:none}.text-ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./client/css/base.css
 ** module id = 561
 ** module chunks = 0
 **/